
import { cfg } from '../config';
import ol from 'openlayers';

export class MapController {
    // private registered_click_once_callbacks_override_default: ((pixel: [number], xy: [number], feature?: any) => void)[] = [];
    private registered_click_callbacks_list: ((pixel: [number], xy: [number], feature?: any) => void)[] = [];
    private registered_move_callbacks_list: ((pixel: [number], xy: [number], feature?: any) => void)[] = [];
    private registered_drag_callbacks_list: ((pixel: [number], xy: [number], feature?: any) => void)[] = [];
    private registered_mousedown_callbacks_list: ((pixel: [number], xy: [number], feature?: any) => void)[] = [];
    private registered_mouseup_callbacks_list: ((pixel: [number], xy: [number], feature?: any) => void)[] = [];

    public map: ol.Map;
    private _parent: HTMLDivElement;
    private _map_div: HTMLDivElement;

    private _tmp_layer: ol.layer.Vector;
    private _tmp_layer_source: ol.source.Vector;

    public interactions = {
        mouseWheelZoom: new ol.interaction.MouseWheelZoom(),
        dragPan: new ol.interaction.DragPan()
    };

    constructor(parent: HTMLDivElement, basemaps: ol.layer.Layer[]) {
        this._parent = parent;

        this._map_div = document.createElement("div");
        this._map_div.id = cfg.mapDivId;
        parent.appendChild(this._map_div);

        this._tmp_layer_source = new ol.source.Vector();
        this._tmp_layer = new ol.layer.Vector({ source: this._tmp_layer_source });


        var attribution = new ol.control.Attribution({
            collapsible: false
          });

        this.map = new ol.Map({
            target: cfg.mapDivId,
            layers: [...basemaps, this._tmp_layer],
            view: new ol.View({
                center: ol.proj.transform(cfg.position.center, 'EPSG:4326', 'EPSG:3857'),
                zoom: cfg.position.zoom
            }),
            interactions: [
                this.interactions.mouseWheelZoom,
                this.interactions.dragPan
            ],//ol.interaction.defaults({ mouseWheelZoom: true })
            controls: [
                new ol.control.Zoom,
                attribution
            ]
        });


        if (cfg.position.extent !== undefined) {
            let p1 = ol.proj.transform([cfg.position.extent[0], cfg.position.extent[1]], 'EPSG:4326', 'EPSG:3857');
            let p2 = ol.proj.transform([cfg.position.extent[2], cfg.position.extent[3]], 'EPSG:4326', 'EPSG:3857');
            this.zoomTo([p1[0], p1[1], p2[0], p2[1]], {});
        }

        this.map.on('click', ((evt: { pixel: [number], coordinate: [number], dragging: boolean, originalEvent: any }) => {
            if (!evt.dragging) {
                this.registered_click_callbacks_list.forEach(f => {
                    f(evt.pixel, evt.coordinate);
                })
            }
        }).bind(this));


        this.map.on('pointermove', ((evt: { pixel: [number], coordinate: [number], dragging: boolean, originalEvent: any }) => {
            if (!evt.dragging) {
                this.registered_move_callbacks_list.forEach(f => {
                    f(evt.pixel, evt.coordinate);
                })
            } else {
                this.registered_drag_callbacks_list.forEach(f => {
                    f(evt.pixel, evt.coordinate);
                })
            }
        }).bind(this));


        this.map.getTargetElement().addEventListener('pointerdown', (e) => {
            let evt: any = { pixel: this.map.getEventPixel(e), coordinate: this.map.getEventCoordinate(e) };
            this.registered_mousedown_callbacks_list.forEach(f => {
                f(evt.pixel, evt.coordinate);
            });
        });


        this.map.getTargetElement().addEventListener('pointerup', (e) => {
            let evt: any = { pixel: this.map.getEventPixel(e), coordinate: this.map.getEventCoordinate(e) };
            this.registered_mouseup_callbacks_list.forEach(f => {
                f(evt.pixel, evt.coordinate);
            });
        });
    }




    register_click_callback(fn: ((pixel: [number], xy: [number], feature?: any) => void)) {
        this.registered_click_callbacks_list.push(fn);
    }


    register_move_callback(fn: ((pixel: [number], xy: [number], feature?: any) => void)) {
        this.registered_move_callbacks_list.push(fn);
    }

    register_drag_callback(fn: ((pixel: [number], xy: [number], feature?: any) => void)) {
        this.registered_drag_callbacks_list.push(fn);
    }

    register_mousedown_callback(fn: ((pixel: [number], xy: [number], feature?: any) => void)) {
        this.registered_mousedown_callbacks_list.push(fn);
    }

    register_mouseup_callback(fn: ((pixel: [number], xy: [number], feature?: any) => void)) {
        this.registered_mouseup_callbacks_list.push(fn);
    }


    // register_click_once_callback(fn: ((pixel: [number], xy: [number], feature?: any) => void)) {
    //     this.registered_click_once_callbacks_override_default.push(fn);
    // }


    public flash_point(coordinates: [number, number], duration_ms: number) {
        let geom = new ol.geom.Point(ol.proj.fromLonLat(coordinates));
        let feature = new ol.Feature(geom);
        feature.setStyle(new ol.style.Style({
            image: new ol.style.Circle({
                radius: 3,
                fill: new ol.style.Fill({
                    color: [255, 0, 0, 1.0]
                })
            })
        }));

        this._tmp_layer_source.addFeature(feature);

        let start = +new Date();
        let listenerKey: ol.Object | ol.Object[]; // to remove the listener after the duration

        let animate = (event: any) => {
            // canvas context where the effect will be drawn
            var vectorContext = event.vectorContext;
            var frameState = event.frameState;

            // create a clone of the original ol.Feature
            // on each browser frame a new style will be applied
            var flashGeom = new ol.geom.Point((<ol.geom.Point>feature.getGeometry()).getCoordinates()); // clone
            var elapsed = frameState.time - start;
            var elapsedRatio = elapsed / duration_ms;
            // radius will be 5 at start and 30 at end.
            var radius = ol.easing.easeOut(elapsedRatio) * 25 + 5;
            var opacity = ol.easing.easeOut(1 - elapsedRatio);

            // you can customize here the style
            // like color, width
            var style = new ol.style.Style({
                image: new ol.style.Circle({
                    radius: radius,
                    snapToPixel: false,
                    stroke: new ol.style.Stroke({
                        color: [51, 51, 51, opacity],
                        width: 0.25 + opacity
                    })
                })
            });

            vectorContext.setStyle(style);
            vectorContext.drawGeometry(flashGeom);
            if (elapsed > duration_ms) { // stop the effect
                ol.Observable.unByKey(listenerKey);
                this._tmp_layer_source.removeFeature(feature);
                return;
            }
            // tell OL3 to continue postcompose animation
            this.map.render();
        }

        listenerKey = this.map.on('postcompose', animate);
    }


    public dispose() {
        this._parent.removeChild(this._map_div);
    }


    public zoomTo(extent: [number, number, number, number], options: { duration?: number, factor?: number, bounce?: boolean }) {
        if (options.factor !== undefined) {
            let w = extent[2] - extent[0]; let h = extent[3] - extent[1]; let c0 = [extent[0] + w / 2, extent[1] + h / 2];
            w = w * options.factor;
            extent = [c0[0] - w / 2, c0[1] - h / 2, c0[0] + w / 2, c0[1] + h / 2];
        }

        let view = this.map.getView();
        if (options.bounce === true && options.duration !== undefined) {
            let resolution = view.getResolutionForExtent(extent);
            let zoom = view.getZoomForResolution(resolution);
            var center = ol.extent.getCenter(extent);
            view.animate({
                center: center,
                duration: options.duration
            });
            view.animate({
                zoom: zoom - 1,
                duration: options.duration / 2
            }, {
                    zoom: zoom,
                    duration: options.duration / 2
                });
        } else {
            view.fit(extent, { duration: options.duration });
        }


        this.map.updateSize();

    }

}
